<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/MyTeam/components/Program'

    export default {
        components: {
            Grid,
        }
    }
</script>